import { useMemo, createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const interactionContext = /*#__PURE__*/createContext({
  /**
   * Will be triggered every time an input within the component is focused.
   */
  onActivate: () => {
    /** no-op */
  }
});
/**
 * contains different callbacks that may be triggered when interacting with
 * the i-guide content.
 */
function ComponentInteractionsProvider(props) {
  const interactions = useMemo(() => ({
    onActivate: props.onActivate
  }), [props.onActivate]);
  return /*#__PURE__*/jsx(interactionContext.Provider, {
    value: interactions,
    children: props.children
  });
}
function useComponentInteractions() {
  return useContext(interactionContext);
}

export { ComponentInteractionsProvider, useComponentInteractions };
//# sourceMappingURL=context.interactions.js.map
